import $ from 'jquery';
import 'slick-carousel';

const defaults = {
  speed: 200,
  dots: true,
  arrows: false,
  dotsClass: 'dots',
  appendDots: '.slick-nav',
  adaptiveHeight: true,
};

export default class NewsSlider {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.slickCarousel = this.build();
    this.$element.addClass('ready');
  }

  build() {
    return this.$element.find('.view-content').slick(this.settings);
  }
}



// WEBPACK FOOTER //
// ./NewsSlider.js